import api, { adminApiPrefix } from './Api';
import {
  PazaramaOrderFilter,
  pazaramaOrderFilterToQueryParams,
} from '../interfaces/Pazarama/PazaramaOrderFilter';
import { PaginatedResponse } from '../interfaces/PaginatedResponse';
import {
  PazaramaOrder,
  pazaramaOrderFromResponse,
} from '../interfaces/Pazarama/PazaramaOrder';

const pazaramaAdminApiPrefix = `${adminApiPrefix}/pazarama`;

export const getPazaramaOrders = async (
  filter: PazaramaOrderFilter,
): Promise<PaginatedResponse<PazaramaOrder>> => {
  const response = await api.get(`${pazaramaAdminApiPrefix}/orders`, {
    params: pazaramaOrderFilterToQueryParams(filter),
  });

  return {
    data: (response.data?.data ?? []).map(pazaramaOrderFromResponse),
    totalCount: response.data?.total_count ?? 0,
  };
};

export const checkPazaramaStatus = async (): Promise<void> =>
  api.get(`${pazaramaAdminApiPrefix}/status`);
